// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('order.purchaseordernew', {
        url: '/purchaseorder/new',
        templateUrl: 'main/order/purchaseorder/purchaseorder.tpl.html',
        controller: 'PurchaseOrderController as vm',
        resolve: {
            companies: companiesResolver,
            locations: locationsResolver,
            collections: collectionsResolver,
            isNewPurchaseOrder: function() {return true;},
            purchaseOrder: function() {return {};}
        }
    });

    $stateProvider.state('order.purchaseorder', {
        url: '/purchaseorder/{purchaseOrderId}',
        templateUrl: 'main/order/purchaseorder/purchaseorder.tpl.html',
        controller: 'PurchaseOrderController as vm',
        resolve: {
            companies: companiesResolver,
            locations: locationsResolver,
            collections: collectionsResolver,
            isNewPurchaseOrder: function() {return false;},
            purchaseOrder: purchaseOrderResolver
        }
    });
}

function companiesResolver(CompaniesApiService) {
    return CompaniesApiService.getAll();
}

// @ngInject
function locationsResolver(LocationsApiService) {
    return LocationsApiService.listAll();
}

// @ngInject
function collectionsResolver(OrdersApiService) {
    return OrdersApiService.getOrderCollections();
}

// @ngInject
function purchaseOrderResolver(OrdersApiService, $stateParams) {
    return OrdersApiService.getPurchaseOrder($stateParams.purchaseOrderId);
}

// @ngInject
function PurchaseOrderController($q, $state, $scope, companies, locations, isNewPurchaseOrder, collections, purchaseOrder,
    ProductsApiService, OrdersApiService, loadSpinnerService, ToasterService) {

    var vm = this;

    vm.isNewPurchaseOrder = isNewPurchaseOrder;
    vm.collections = collections;
    vm.companies = companies;
    vm.locations = locations;
    vm.article = {}; // The currently selected article to chose quantities for
    vm.selectedColorVariant = {}; // The color variant of the currently selected article to be displayed
    vm.orderChangeCount = 0;
    vm.selectArticles = selectArticles;
    vm.purchaseOrderChanged = purchaseOrderChanged;
    vm.articleIds = [];

    vm.save = save;

    vm.selectArticle = selectArticle;
    vm.selectColor = selectColor;
    vm.recieveArticles = recieveArticles;

    activate();

    function activate() {
        if (!isNewPurchaseOrder) {
            vm.purchaseOrder = purchaseOrder;
            vm.company = vm.purchaseOrder.company;
        } else {
            vm.purchaseOrder = generateEmptyPurchaseOrder();
        }

        if (!isNewPurchaseOrder) {
            initializeOrderEditing();
        }

        $scope.$watch(function() { return vm.purchaseOrder.articleCollection.id; }, function() {
            _.forEach(vm.purchaseOrder.orders, function(order) { order.collection = vm.purchaseOrder.articleCollection; });
        });

        $scope.$watch(function() { return vm.purchaseOrder.plannedDeliveryDate; }, function() {
            _.forEach(vm.purchaseOrder.orders, function(order) { order.plannedDeliveryDate = vm.purchaseOrder.plannedDeliveryDate; });
        });
    }

    function selectArticles(orderArticles) {
        return function() {
            return orderArticles.map(function(oa) {
                return { id: oa.articleId };
            });
        };
    }

    // General setup
    function initializeOrderEditing() {
        // Setting the purchaseOrder's collection for easier access.
        vm.purchaseOrder.articleCollection = vm.purchaseOrder.orders[0].collection;
    }

    // Save the current purchaseOrder
    function save() {
        var isNewPurchaseOrder = vm.purchaseOrder.id === 0;

        var minimizedPurchaseOrder = removeUnnecessaryPurchaseOrderData(vm.purchaseOrder);

        if (!isNewPurchaseOrder) {
            loadSpinnerService.start('mainSpinner');
            OrdersApiService.updatePurchaseOrder(minimizedPurchaseOrder).then(function(response) {
            }, function(error) {
                console.log(error);
            }).finally(function() {
                loadSpinnerService.stop('mainSpinner');
            });

        } else { // Create purchase order.
            loadSpinnerService.start('mainSpinner');
            OrdersApiService.createPurchaseOrder(minimizedPurchaseOrder).then(function(response) {
                $state.go('order.purchaseorder', {purchaseOrderId: response.data.id});
            }, function(error) {
                console.log(error);
            }).finally(function() {
                loadSpinnerService.stop('mainSpinner');
            });
        }

    }

    function removeUnnecessaryPurchaseOrderData(purchaseOrder) 
    {
        var newPurchaseOrder = {
            id: purchaseOrder.id,
            orderNumber: purchaseOrder.orderNumber,
            orderNumberExternal: purchaseOrder.orderNumberExternal,
            plannedDeliveryDate: purchaseOrder.plannedDeliveryDate,
            goesThroughStorageLocation: purchaseOrder.goesThroughStorageLocation,
            storageLocation: { id: purchaseOrder.storageLocation.id },
            articleCollection: { id: purchaseOrder.articleCollection.id },
            orderChange: purchaseOrder.orderChange,
            orderChangeDate: purchaseOrder.orderChangeDate,
            company: { id: purchaseOrder.company.id },
            orderStatus: purchaseOrder.orderStatus,
            orders: []
        };

        _.forEach(purchaseOrder.orders, function(o) {
            var newOrder = {
                id: o.id,
                orderNumber: o.orderNumber,
                orderNumberExternal: o.orderNumberExternal,
                plannedDeliveryDate: o.plannedDeliveryDate,
                collection: { id: o.collection.id },
                destination: { id: o.destination.id },
                orderArticles: []
            };

            _.forEach(o.orderArticles, function(oa) {
                var newOrderArticle = { 
                    id: oa.id,
                    article: { id: oa.article.id },
                    orderRows: []
                };
                _.forEach(oa.orderRows, function(ordRow) {
                    if(ordRow.quantity !== 0 && ordRow.id === 0) {
                        newOrderArticle.orderRows.push({
                            id: ordRow.id,
                            orderStatus: ordRow.orderStatus,
                            articleVariant: { 
                                id: ordRow.articleVariant.id,
                                barcode: ordRow.articleVariant.barcode
                            },
                            purchaseCost: ordRow.purchaseCost,
                            quantity: ordRow.quantity
                        });
                    }
                });
                if (newOrderArticle.orderRows.length !== 0) {
                    newOrder.orderArticles.push(newOrderArticle);
                }
            });

            if (newOrder.orderArticles.length !== 0) {
                newPurchaseOrder.orders.push(newOrder);
            }
        });

        newPurchaseOrder.articleCollection = {id: purchaseOrder.articleCollection.id };
        newPurchaseOrder.company = { id: purchaseOrder.company.id };

        return newPurchaseOrder;
    }

    // Change the currently selected article
    function selectArticle(article) {
        vm.article = article;
    }

    // Change the currently selected color
    function selectColor(colorVariant) {
        vm.selectedColorVariant = colorVariant;
    }

    function recieveArticles(articles) {
        var promises = [];
        loadSpinnerService.start("mainSpinner");
        _.forEach(articles, function(article) {
            var articleFetchPromise = ProductsApiService.getProduct(article.id);
            promises.push(articleFetchPromise);
        });

        $q.all(promises).then(function(responses) {
            _.forEach(vm.purchaseOrder.orders, function(order) {
                _.forEach(responses, function(article) {
                    order.orderArticles.push({
                        id: 0,
                        article: article
                    });
                });
            });

            vm.orderChangeCount += 1;
        }, function(error) {
            ToasterService.showError(error.message);
        }).finally(function() {
            loadSpinnerService.stop("mainSpinner");
        });
    }

    // Builds an empty purchase order to use as a base when starting to edit.
    function generateEmptyPurchaseOrder() {
        var purchaseOrder = {
            id: 0,
            orderNumber: 0,
            orderNumberExternal: 0,
            article: {},
            orderStatus: {},
            orders: [],
            plannedDeliveryDate: new Date(),
            goesThroughStorageLocation: false,
            storageLocation: {},
            articleCollection: {},
            orderChange: false,
            orderChangeDate: new Date(),
            company: {}
        };

        _.forEach(vm.locations, function(location) {
            var order = {
                id: 0,
                orderArticles: [],
                destination: location
            };

            purchaseOrder.orders.push(order);
        });
        return purchaseOrder;
    }

    function purchaseOrderChanged(purchaseOrder) {
        vm.purchaseOrder = purchaseOrder;
        vm.orderChangeCount += 1;
    }
}

angular
    .module('order.purchaseorder', [])
    .config(stateConfig)
    .controller('PurchaseOrderController', PurchaseOrderController);
